// extracted by mini-css-extract-plugin
module.exports = {"clientSearchInput":"clientSearchInput_clientSearchInput__QUSZ8"};